import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { getFullImageUrl } from 'client/utils/image-helpers';
import { IMAGE_SIZES } from 'site-modules/shared/constants/editorial/editorial';
import { SectionHeading } from 'site-modules/shared/components/editorial/section-heading/section-heading';

import './content-list.scss';

export function ContentList({ entry }) {
  const { hrList, title, linkout } = (() => {
    const data = entry.getAllMetadata();
    return {
      hrList: data['hr-list'],
      title: data.title,
      linkout: {
        href: data['view-more-url'],
        text: data['view-more-title'],
      },
    };
  })();

  function parseLink(link) {
    const metadata = link.getAllMetadata();
    return {
      href: metadata['item-link'],
      name: metadata['item-title'],
      image: metadata['item-image'],
      topImage: metadata['item-image-top'],
      text: metadata['item-text'],
      author: metadata.author,
      'publish-date': metadata['publish-date'],
      sponsoredTitle: metadata['sponsored-title'],
    };
  }
  const links = entry.children().map(link => parseLink(link));

  return (
    <div className={classnames('content-list small', { 'hr-list': hrList })}>
      <SectionHeading linkout={linkout} linkoutText={linkout.text}>
        {title}
      </SectionHeading>
      <ul className="list-unstyled">
        {links.map(item => (
          <li
            key={`${item.name}-${item.href}`}
            className={`px-1 content-list-item d-flex align-items-start py-0_75 ${!!item.topImage && 'flex-wrap'}`}
          >
            {!!item.topImage && (
              <a href={item.href} className="mb-0_5 content-list-item-top-image-wrapper w-100">
                <img
                  src={getFullImageUrl(item.topImage, IMAGE_SIZES.sm)}
                  alt={item.name}
                  className="content-list-item-top-image w-100"
                />
              </a>
            )}
            {!!item.image && (
              <img
                src={getFullImageUrl(item.image, IMAGE_SIZES.xs)}
                alt={item.name}
                className="me-1_5 content-list-item-image"
              />
            )}
            <div>
              {item.sponsoredTitle && (
                <div className="text-uppercase text-primary size-10 pb-0_5 fw-bold">Sponsored Content</div>
              )}
              <a
                href={item.href}
                className="fw-bold"
                title={item.name}
                data-tracking-value={`${item.name} - right`}
                data-tracking-id="inline_article_view_content"
              >
                {item.name}
              </a>
              {item.text && <div className="content-list-item-details py-0_25">{item.text}</div>}
              {(!!item.author || !!item['publish-date']) && (
                <div className="content-list-item-details pt-0_25">
                  {!!item.author && <span>{item.author}</span>}
                  {!!item.author && !!item['publish-date'] && <span className="divider px-0_5" />}
                  {!!item['publish-date'] && <span>{item['publish-date']}</span>}
                </div>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

ContentList.propTypes = {
  entry: PropTypes.shape({}).isRequired,
};
